function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Organization",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Contractor-detail-view",
  transform: "translate(-755.000000, -497.000000)",
  fill: "#E87218",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(698.000000, 497.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.0889322,0.506485384 L62.3117989,4.27114482 L58.3357013,4.87678867 C57.6226708,4.9848378 57.3369143,5.90325548 57.8539975,6.42928417 L60.730613,9.35798448 L60.0502403,13.4951291 C59.9277733,14.2429429 60.6816261,14.8030923 61.3130119,14.4533543 L64.87,12.4999397 L68.4269881,14.4533543 C69.0583739,14.8002489 69.8122267,14.2429429 69.6897597,13.4951291 L69.009387,9.35798448 L71.8860025,6.42928417 C72.4030857,5.90325548 72.1173292,4.9848378 71.4042987,4.87678867 L67.4282011,4.27114482 L65.6510678,0.506485384 C65.3326534,-0.16455663 64.4100681,-0.173086825 64.0889322,0.506485384 Z",
  id: "Star_2",
  transform: "translate(64.870000, 7.280000) scale(-1, 1) translate(-64.870000, -7.280000) "
})))));

function SvgStarOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOrange);
export default __webpack_public_path__ + "static/media/star-orange.974a8f1f.svg";
export { ForwardRef as ReactComponent };